import { render } from "./add-reports.vue?vue&type=template&id=ce3574ac&scoped=true"
import script from "./add-reports.vue?vue&type=script&lang=js"
export * from "./add-reports.vue?vue&type=script&lang=js"

import "./add-reports.vue?vue&type=style&index=0&id=ce3574ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3574ac"]])

export default __exports__